import React from 'react';
import Breadcrumb from '../Breadcrumb';

interface TestProps {
  projectId: string;
}

const Test: React.FC<TestProps> = ({ projectId }) => {
  return (
    <div className="module-content">
      <Breadcrumb items={[
        { label: 'Home', path: '/' },
        { label: 'Projects', path: '/' },
        { label: projectId, path: `/project/${projectId}` },
        { label: 'Test' }
      ]} />
      <h2>Test LLM Application</h2>
      <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
        <div className="info-card dataset-card" onClick={() => window.location.href = `/project/${projectId}/test/dataset`} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ margin: '0 0 0.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '1.5rem' }}>📊</span>
            Dataset
          </h3>
          <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>Manage test datasets</p>
        </div>
        <div className="info-card dataset-card" onClick={() => window.location.href = `/project/${projectId}/test/evaluation`} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ margin: '0 0 0.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span style={{ fontSize: '1.5rem' }}>📈</span>
            Evaluation
          </h3>
          <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>Run evaluations</p>
        </div>
      </div>
    </div>
  );
};

export default Test;